import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { clearStoredLocale } from '~/common/utils/signed-out-locale.utils';
import { selectProfileId } from '~/store/profile/profileSlice.selectors';

/**
 * Drops the language a signed-out visitor picked once a profile has loaded.
 * After logout the sign-in page then falls back to the active app language,
 * which the profile set, so it and the account-creation page it opens speak
 * the user's language rather than a choice made before sign-in.
 */
const useClearStoredLocaleOnSignIn = (): void => {
  const profileId = useSelector(selectProfileId);

  useEffect(() => {
    if (profileId) {
      clearStoredLocale();
    }
  }, [profileId]);
};

export default useClearStoredLocaleOnSignIn;
